<template>
  <div class="mem-edit">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
      <FormItem label="会员计划名称" prop="name">
        <Input v-model="formValidate.name" style="width: 300px;" clearable></Input>
      </FormItem>
      <FormItem label="会员时效" prop="time">
        <RadioGroup v-model="formValidate.time">
          <Radio label="1">1个月</Radio>
          <Radio label="3">3个月</Radio>
          <Radio label="6">6个月</Radio>
          <Radio label="12">12个月</Radio>
          <Radio label="111">自定义天数</Radio>
        </RadioGroup>
        <span v-show="formValidate.time == '111'">
          <Input style="width:100px;" v-model="day" placeholder="请输入天数" />天
        </span>
      </FormItem>
      <FormItem label="会员类型" prop="grade_type">
        <RadioGroup v-model="formValidate.grade_type">
          <Radio label="1">购买</Radio>
          <Radio label="2">赠送</Radio>
        </RadioGroup>
        <div style="color: #999;">*赠送类型的会员在前台的购买页面不显示</div>
      </FormItem>
      <FormItem label="会员价格" v-show="formValidate.grade_type == 1" prop="price">
        <Input type="number" v-model="formValidate.price" style="width: 300px;"></Input>
      </FormItem>
      <FormItem label="排序" prop="sort">
        <Input type="number" v-model="formValidate.sort" style="width: 300px;"></Input>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'MemberPlan'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submits('formValidate')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  name: "PlanEdit",
  data() {
    return {
      id: this.$route.query.id,
      mobile: "",
      formValidate: {
        name: "",
        time: "",
        grade_type: "",
        price: "",
        sort: ""
      },
      day: "",
      ruleValidate: {
        name: { required: true, message: "请输入" },
        time: { required: true, message: "请选择" },
        grade_type: { required: true, message: "请选择" },
        sort: { required: true, message: "请输入" }
      },
      showSelectUser: false,
      vipGrade: []
    };
  },
  async created() {
    await this.getvipGrade();
  },
  methods: {
    async getvipGrade() {
      if (this.id) {
        let data = await this.$http.get("/api/vipGrade/" + this.id);
        if (data.day) {
          this.day = data.day;
          this.formValidate.time = "111";
        } else {
          this.formValidate.time = data.month.toString();
        }
        this.formValidate.name = data.name;
        this.formValidate.grade_type = data.grade_type.toString();
        this.formValidate.price = this.$pub.calcPrice(data.price);
        this.formValidate.sort = data.sort;
      }
    },
    UserDelete(id) {
      let users = this.formValidate.users;
      for (let i = 0; i < users.length; i++) {
        if (users[i].uid == id) {
          users.splice(i, 1);
          this.mobile = "";
          break;
        }
      }
    },
    confirmSelectUser() {
      this.showSelectUser = false;
      let list = this.$refs.user.getSelectList();
      this.formValidate.users = list;
      this.mobile = list[0].mobile;
    },
    submits(name) {
      this.$refs[name].validate(async valid => {
        if (!valid) {
          return;
        }
        let obj = {
          name: this.formValidate.name,
          grade_type: this.formValidate.grade_type,
          year: "0",
          sort: this.formValidate.sort
        };
        if (obj.grade_type == 1) {
          if (!this.formValidate.price) {
            this.$Message.error("请输入会员价格");
            return;
          }
          obj.price = this.formValidate.price;
        } else {
          obj.price = 0;
        }
        if (this.formValidate.time == "111") {
          obj.day = this.day;
          obj.month = "0";
        } else {
          obj.month = this.formValidate.time;
          obj.day = "0";
        }
        if (this.id) {
          obj.vip_grade_id = this.id;
          await this.$http.put("/api/vipGrade/" + this.id, obj);
        } else {
          await this.$http.post("/api/vipGrade", obj);
        }
        this.$Message.saveSuccess();
        this.$router.push({
          name: "MemberPlan"
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.mem-edit {
  padding: 20px;
}
</style>

